import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Accueil from '@/components/Accueil.vue'
import Entreprise from '@/components/Entreprise.vue'
import Prestations from '@/components/Prestations.vue'
import Realisation from '@/components/Realisation.vue'
import Contact from '@/components/Contact.vue'
import MentionsLegales from '@/components/MentionsLegales.vue'

Vue.use(VueRouter)
Vue.use(Meta)

export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'accueil',
            component: Accueil,
        },
        {
            path: '/entreprise.html',
            name: 'entreprise',
            component: Entreprise
        },
        {
            path: '/prestations.html',
            name: 'prestations',
            component: Prestations
        },
        {
            path: '/realisation/:title-:id.html',
            name: 'realisation',
            component: Realisation
        },
        {
            path: '/contact.html',
            name: 'contact',
            component: Contact
        },
        {
            path: '/mentions-legales.html',
            name: 'mentions-legales',
            component: MentionsLegales
        },
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
      }
});